export var dynamicLedgerFilters;
(function (dynamicLedgerFilters) {
    dynamicLedgerFilters["simpleFilter"] = "Voucher";
    dynamicLedgerFilters["assetFilter"] = "Exchange";
})(dynamicLedgerFilters || (dynamicLedgerFilters = {}));
